import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}
export function Label(props: Props) {
  const { children } = props
  return (
    <Typography variant="caption" color="text.secondary">
      {children}
    </Typography>
  )
}
